
    <!-- <div class="modal-header">
        <span class="modal-header-title"> {{ 'DIALOG.ATTRIBUTE.ACSESS_SETTING' | translate }}</span>
        <div class="tool">
            <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss(false)">
                <span aria-hidden="true">&times;</span>
            </button>
       </div>
    </div> -->
    <div class="size">
        <div class="modal-body">
            <div class="category-main-block">
                
                <div class="col-6 category-child-block">
                    <app-tree-view (changeItem)="eventCategoryList($event)" [instance]="myItems" [header]="treeHeader" [categoryType]="categoryType"></app-tree-view>
                </div>
            
            
                <div class="col-6 category-child-block">
                    <!-- list -->
                    <div class="row">
                        <div class="col-12">
                            <div class="card">
                                <div class="card-header">
                                    <div class="title">{{ 'FILES.PREVIEW_CATEGORIES_LIST_OF_FILE_SISTEM' | translate }}</div>
                                </div>
            
                                <div class="card-body">
            
                                    <ul id="myUl" *ngIf="filteredCatgory.length == 0">
                                        <ng-container *ngTemplateOutlet="Recursion; context:{ list: items}"></ng-container>
                                    </ul>
            
                                    <ng-template #Recursion let-list="list">
            
                                            <li class="category-item" *ngFor="let item of list; let i = index">
            
                                                <div class="name-text-info">
            
                                                    <i *ngIf="item.children.length > 0" 
                                                        [ngClass]="item.isOpen ? 'bi bi-caret-down-fill' : 'bi bi-caret-right-fill'"
                                                        (click)="item.isOpen = !item.isOpen">
                                                    </i>
            
                                                    <label [ngClass]="item.children.length > 0 ? 'box' : 'non-children-box' ">
                                                        {{ item.name }}
                                                    </label>
            
                                                </div>
            
                                                <ul *ngIf="item.children != null && item.children.length > 0 && item.isOpen">
            
                                                    <ng-container *ngTemplateOutlet="Recursion; context:{ list: item.children }"></ng-container>
            
                                                </ul>
            
                                            </li>
            
                                    </ng-template>
            
                                </div>
            
                            </div>
            
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- <div class="modal-footer btn-box">
        <button type="button" class="btn btn-light btn-sm"   (click)="activeModal.dismiss(false)">{{ 'CLOSE' | translate}}</button>
    </div> -->
